import React from 'react';
import styled from '@emotion/styled';

export interface GoogleAuthProps {
  onClick: () => void;
  disabled: boolean;
}

export default function GoogleAuth({ disabled, onClick }: GoogleAuthProps) {
  const src = disabled ? 'images/google-signin-disabled.png' : 'images/google-signin.png';


  return (
    <StyledImage disabled={disabled} onClick={onClick} src={src} />
  );
}

interface StyledImageProps {
  disabled?: boolean;
}
const StyledImage = styled.img<StyledImageProps>(({ disabled }) => ({
  cursor: disabled ? 'not-allowed' : 'pointer',
  width: 308,
  resizeMode: 'contain',
}));
